import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ApiService from '../services/ApiService';
import Loader from '../components/Loader';

const ResetPassword = () => {
    const navigate = useNavigate();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');
    const [type, setType] = useState('user');
    const [isLoader, setIsLoader] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const emailParam = params.get('email') || '';
        const tokenParam = params.get('token') || '';
        const typeParam = params.get('type') || 'user';
        setEmail(emailParam);
        setToken(tokenParam);
        setType(typeParam === 'customer' ? 'customer' : 'user');
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            toast.error('Passwords do not match');
            return;
        }
        setIsLoader(true);
        try {
            const response = await ApiService.request({
                method: 'POST',
                url: '/reset-password',
                data: {
                    email,
                    token,
                    password,
                    password_confirmation: confirmPassword,
                    type,
                },
            });
            if (response.data.status) {
                toast.success(response.data.message);
                navigate('/login');
            } else {
                toast.error(response.data.message || 'Failed to reset password');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to reset password');
        } finally {
            setIsLoader(false);
        }
    };

    if (!email || !token) {
        return (
            <div className="page-body-wrapper full-page-wrapper bg-light">
                <div className="row w-100 m-0 full-page-wrapper">
                    <div className="content-wrapper full-page-wrapper d-flex align-items-center auth">
                        <div className="col-lg-4 mx-auto">
                            <div className="card">
                                <div className="card-body px-5 py-5 text-center">
                                    <p>Invalid or missing reset link.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-body-wrapper full-page-wrapper bg-light">
            <div className="row w-100 m-0 full-page-wrapper">
                <div className="content-wrapper full-page-wrapper d-flex align-items-center auth">
                    <div className="col-lg-4 mx-auto">
                        <div className="card">
                            <div className="card-body px-5 py-5">
                                <div className="text-center my-3">
                                    <h3 className="card-title mb-0 fs-2">Reset Password</h3>
                                    <p>Set a new password for your account.</p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group my-4">
                                        <label>New Password *</label>
                                        <input
                                            type="password"
                                            required
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            className="form-control p_input"
                                            placeholder="New Password"
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="form-group my-4">
                                        <label>Confirm Password *</label>
                                        <input
                                            type="password"
                                            required
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            className="form-control p_input"
                                            placeholder="Confirm Password"
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="text-center">
                                        <button type="submit" className="btn btn-base w-100 mt-4" disabled={isLoader}>
                                            {isLoader ? <Loader /> : 'Reset Password'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;

